import React from 'react'
import styled from 'styled-components'
import Logo from '../../static/images/branding/OE_QuestForwardLearningTM_forDark.svg'
import { getCurrentYear } from '../../utils/date'

const CopyrightWrapper = styled.div`
  position: absolute;
  bottom: -180px;
  left: 50%;
  width: 400px;
  margin: 0 auto;
  transform: translateX(-50%);
`

const CopyrightText = styled.p`
  margin: 0 auto;
  text-align: center;
  line-height: 20px;
  font-size: 13px;
  color: #fff;
`

const Image = styled.img`
  margin: 0 auto 26px;
  display: block;
  width: 250px;
  height: auto;
`

const Copyright = () => (
  <CopyrightWrapper>
    <Image
      src={Logo}
      alt="Opportunity Education and Quest Forward Learning&trade;"
    />
    <CopyrightText>
      {`© 2012-${getCurrentYear()} Opportunity Education Foundation, Inc.`}
      <br />
      Quest Forward Learning&trade; | All rights reserved.
    </CopyrightText>
  </CopyrightWrapper>
)

export default Copyright
